import { SVGProps, Ref, forwardRef } from "react";

const EyeIcon = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 19 14"
    fill="none"
    width="1em"
    height="1em"
    ref={ref}
    aria-label="Eye Icon"
    {...props}
  >
    <title id="Eye Icon">Eye Icon</title>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.67}
      d="M1.055 7.263c-.114-.18-.17-.27-.202-.409a.977.977 0 0 1 0-.372c.032-.138.088-.228.202-.408C1.993 4.589 4.785.835 9.038.835c4.255 0 7.046 3.754 7.984 5.239.114.18.17.27.202.408a.98.98 0 0 1 0 .372c-.032.14-.088.229-.202.409-.938 1.485-3.73 5.239-7.984 5.239s-7.045-3.754-7.983-5.24Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.67}
      d="M9.038 9.168a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
    />
  </svg>
);

const ForwardRef = forwardRef(EyeIcon);
export default ForwardRef;
